(function () {
  var BLOCK_TAGS = ['shipping-protection'];
  var BLOCK_HANDLES = ['shipping-protection','versandschutz','protezione-spedizione','verzendingsbescherming','co2-neutral-shipping-protection'];
  function norm(v) { return String(v == null ? '' : v).trim().toLowerCase(); }
  function isBlocked(upsell) {
    if (!upsell) return false;
    if (BLOCK_HANDLES.indexOf(norm(upsell.handle)) !== -1) return true;
    var tags = upsell.tags;
    if (typeof tags === 'string') tags = tags.split(',');
    if (Object.prototype.toString.call(tags) !== '[object Array]') return false;
    for (var i = 0; i < tags.length; i++) { if (BLOCK_TAGS.indexOf(norm(tags[i])) !== -1) return true; }
    return false;
  }
  window.upcartModifyListOfUpsells = function (upsells) {
    try {
      if (Object.prototype.toString.call(upsells) !== '[object Array]') return upsells;
      return upsells.filter(function (u) { return !isBlocked(u); });
    } catch (e) { return upsells; }
  };
})();